import { render, staticRenderFns } from "./IcoEndosoMov.vue?vue&type=template&id=5143cefd&scoped=true"
import script from "./IcoEndosoMov.vue?vue&type=script&lang=ts"
export * from "./IcoEndosoMov.vue?vue&type=script&lang=ts"
import style0 from "./IcoEndosoMov.vue?vue&type=style&index=0&id=5143cefd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143cefd",
  null
  
)

export default component.exports